import { useTranslation } from "react-i18next"
import { Button } from "../../App.styles"
import Modal from "../Modal"

const HelpModal = ({ onDismiss, show, title = '', children = null }) => {
    const { t } = useTranslation()

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{title}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                { children }
            </div>
            <div className="modal-footer">
                <Button color="dark" className="btn--flat" data-dismiss="modal" onClick={onDismiss}>
                    {t('Close')}
                </Button>
            </div>
        </Modal>
    )
}

export default HelpModal
